import React from 'react';
import { useAddColumnMutation } from '@/redux';
import { useAppFindFormik } from '@/components';
import { AddColumnDto, ProjectDto, ColumnTypesEnum } from '@/core';
import { FormValueType } from './hooks';
import { ColumnForm } from './ColumnForm';

const getInitialValue = (): FormValueType => ({
  sourceName: '',
  name: '',
});

type PropsType = {
  projectData: ProjectDto;
  columnType: ColumnTypesEnum;
};

export const ProjectsAddColumnForm = ({ projectData, columnType }: PropsType) => {
  const form = useAppFindFormik(columnType);
  const [addColumn] = useAddColumnMutation();
  const initialValue = getInitialValue();

  const handleSubmit = (columnData: AddColumnDto) => {
    addColumn({ columnData: { ...columnData, type: columnType }, projectId: projectData.id })
      .unwrap()
      .then(() => form.current?.resetForm());
  };

  return (
    <ColumnForm
      handleSubmit={handleSubmit}
      formUid={columnType}
      columnType={columnType}
      initialValue={initialValue}
      projectData={projectData}
      isTooltip
    />
  );
};
